<template lang="pug">
.warning-container
  v-icon(size="20") $info-warning
  span.warning-container__info {{ warningInfo }}
</template>

<script>
export default {
  name: 'WarningComponent',
  props: {
    warningInfo: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped lang="scss">
.warning-container {
  display: flex;
  gap: .75rem;
  padding: .625rem 1rem;
  background-color: #FEF5EC;
  border-radius: .5rem;
  border: 1px solid #F5DEC6;

  &__info {
    color: #4B4B4B;
    font-size: .75rem;
    font-weight: 400;
    line-height: 150%;
  }
}
</style>
